export const createLruCache = <K, V>(maxSize: number) => {
  const entries = new Map<K, V>()

  // Map keeps insertion order, so re-inserting a key marks it as the most recently used.
  const touch = (key: K, value: V) => {
    entries.delete(key)
    entries.set(key, value)
  }

  return {
    get: (key: K) => {
      const value = entries.get(key)
      if (value !== undefined) touch(key, value)
      return value
    },
    set: (key: K, value: V) => {
      touch(key, value)
      if (entries.size > maxSize) entries.delete(entries.keys().next().value as K)
    },
    clear: () => entries.clear(),
  }
}
